/* global axios */
import ApiClient from './ApiClient';

class SalesAPI extends ApiClient {
  constructor() {
    super('sales', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  dashboard(params = {}) {
    return axios.get(`${this.url}/dashboard`, { params });
  }

  // Conversation-scoped endpoints (multiple sales per conversation)
  getAllForConversation(conversationDisplayId) {
    return axios.get(`${this.baseUrl()}/conversations/${conversationDisplayId}/sales`);
  }

  createForConversation(conversationDisplayId, payload) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationDisplayId}/sales`,
      payload
    );
  }

  updateForConversation(conversationDisplayId, saleId, payload) {
    return axios.patch(
      `${this.baseUrl()}/conversations/${conversationDisplayId}/sales/${saleId}`,
      payload
    );
  }

  cancelForConversation(conversationDisplayId, saleId, payload) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationDisplayId}/sales/${saleId}/cancel`,
      payload
    );
  }
}

export default new SalesAPI();
